<div class="agent-confirmation">
  <mat-icon class="agent-confirmation__icon">help_outline</mat-icon>
  <div class="agent-confirmation__body">
    <p class="agent-confirmation__summary">{{ confirmation().summary }}</p>
    @if (confirmation().changes; as changes) {
      <dl class="agent-confirmation__changes">
        @for (change of changes; track $index) {
          <div class="agent-confirmation__change">
            <dt class="agent-confirmation__field">{{ change.field }}</dt>
            <dd class="agent-confirmation__values">
              @if (change.before !== null) {
                <span class="agent-confirmation__before">{{ change.before }}</span>
                <mat-icon class="agent-confirmation__arrow">arrow_forward</mat-icon>
              }
              <span class="agent-confirmation__after">{{ change.after }}</span>
            </dd>
          </div>
        }
      </dl>
    }
    <div class="agent-confirmation__actions">
      <button type="button" mat-stroked-button class="secondary-button" (click)="deny.emit()">{{ "agent.decline" | translate }}</button>
      <button type="button" mat-flat-button color="primary" (click)="approve.emit()">{{ "agent.approve" | translate }}</button>
    </div>
  </div>
</div>
